export const FETCH_ALL_FULFILLED = 'tune/FETCH_ALL_FULFILLED'
export const FETCH_ALL_FAILED = 'tune/FETCH_ALL_FAILED'
export const FETCH_ALL_PENDING = 'tune/FETCH_ALL_PENDING'
export const RESET = 'tune/RESET'